import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";

// Common schema for metrics
const MetricSchema = Yup.object().shape({
  partners: Yup.number().nullable(),
  campaigns: Yup.number().nullable(),
  links: Yup.number().nullable(),
  clicks: Yup.number().nullable(),
  uniques: Yup.number().nullable(),
  earnings: Yup.number().nullable(),
  orders: Yup.number().nullable(),
  sales: Yup.number().nullable(),
});

// Schema for comparison values
const ComparisonItemSchema = Yup.object().shape({
  value: Yup.number().nullable(),
  percentage: Yup.number().nullable(),
});

// Schema for comparison object
const ComparisonSchema = Yup.object().shape({
  partners: ComparisonItemSchema,
  campaigns: ComparisonItemSchema,
  links: ComparisonItemSchema,
  clicks: ComparisonItemSchema,
  uniques: ComparisonItemSchema,
  earnings: ComparisonItemSchema,
  orders: ComparisonItemSchema,
  sales: ComparisonItemSchema,
});

// Schema for date range
const DateRangeSchema = Yup.object().shape({
  start: Yup.string().nullable(),
  end: Yup.string().nullable(),
});

// Main dashboard stats schema
export const OverviewSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    current: MetricSchema,
    previous: MetricSchema,
    comparison: ComparisonSchema,
    dateRange: Yup.object()
      .shape({
        current: DateRangeSchema,
        previous: DateRangeSchema,
      }),
  });

export default class StatsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = OverviewSchema.cast(json.data, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
